import { VStack } from "@chakra-ui/react";
import RoomEditorTools from "./RoomEditorTools";
import { useEffect } from "react";
import { handleZoomOnlyView } from "../../constants/Helpers";
import {
  useModelStore,
  useRoomStore,
  useUserInterfaceStore,
} from "../../store";

function RoomDecorationsPanel() {
  const setEditingRoom = useUserInterfaceStore((s) => s.setEditingRoom);
  const setRoomEditingTab = useUserInterfaceStore((s) => s.setRoomEditingTab);
  const cameraControls = useModelStore((s) => s.cameraControls);
  const height = useRoomStore((s) => s.height);
  const scaleX = useRoomStore((s) => s.scaleX);
  const scaleZ = useRoomStore((s) => s.scaleZ);

  useEffect(() => {
    setEditingRoom(true);
    setRoomEditingTab(1); // Decorations tab - enables drawing decorations
    handleZoomOnlyView(cameraControls, height, scaleX, scaleZ);
  }, [cameraControls, height, scaleX, scaleZ, setEditingRoom, setRoomEditingTab]);

  return (
    <VStack spacing={4} align="stretch" width="100%">
      <RoomEditorTools />
    </VStack>
  );
}

export default RoomDecorationsPanel;
